import Link from 'next/link';
import styled from 'styled-components';

import useFormatDate from '../../utils/useFormatDate';
import { theme } from '../GlobalStyles';
import Image from '../Image';

const SC = {};
SC.PromoCard = styled.div`
  background: #f0ebf2;
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: start;
  box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.05);

  .partnerName {
    font-size: 1rem;
    font-weight: 300;
    margin: auto 1rem;
  }

  .banner {
    position: relative;
    width: 100%;
    padding-bottom: 52.356%;
  }

  .blankStatus {
    padding: 0.8rem;
  }

  .endingStatus {
    background: #fe01ad;
    border-radius: 2rem;
    color: #fff;
    padding: 0.35rem 0.8rem 0.15rem 0.8rem;
    font-size: 0.8rem;
  }

  .newStatus {
    background: #3fefbf;
    border-radius: 2rem;
    color: black;
    padding: 0.35rem 0.8rem 0.15rem 0.8rem;
    font-size: 0.8rem;
  }

  .status {
    margin: 1rem;
    ${theme.mediaQueries.below.small} {
      margin: 1rem 1rem 0.5rem 1rem;
    }
  }

  h5 {
    margin: 1rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-width: 100%;
    height: 3rem;
    word-break: break-word;
  }

  .promo-period {
    font-weight: 500;
    color: #666;
    margin-bottom: 1rem;
    font-size: 0.7688rem;
    padding: 0 1rem;
  }

  ${theme.mediaQueries.below.small} {
    h5 {
      height: 2.5rem;
    }
    .promo-period {
      padding: 0 2.5rem 0rem 1rem;
    }
  }
`;

const PromoCard = ({ name, banner, partner, isEnding, isNew, startDate, endDate, permalink }) => {
  const { formattedStartDate, formattedEndDate } = useFormatDate(startDate, endDate);
  return (
    <Link href={`/discover/promotion/${permalink}`}>
      <SC.PromoCard>
        <div className="banner">
          <Image
            fill
            alt={name}
            src={banner}
            className="object-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw,33vw"
          />
        </div>
        <div className="status">
          {!isEnding && !isNew && <div className="blankStatus"></div>}
          {isEnding && <div className="endingStatus">Ending soon</div>}
          {isNew && <div className="newStatus">New</div>}
        </div>
        {partner && <div className="partnerName">{partner}</div>}
        <h5>{name}</h5>
        {formattedStartDate && formattedEndDate && (
          <div className="promo-period">
            {formattedStartDate} - {formattedEndDate}
          </div>
        )}
      </SC.PromoCard>
    </Link>
  );
};

export default PromoCard;
